import { FC, useEffect, useState } from "react";
import _ from "lodash";
import { Button, Box, Typography, Backdrop } from "@mui/material";
import Image1 from "../../../assets/images/fingerprint.svg";
import Image2 from "../../../assets/images/Authentication.svg";
import Image3 from "../../../assets/images/LockBiometric.svg";
import Image4 from "../../../assets/images/BiomentricImage4.svg";
import "./CaptureBiometric.scss";
import CustomNetworkImage from "../../../components/CustomNetworkImage/CustomNetworkImage";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { updateLoadingState } from "../../Feature_Loading/Loading_Slice";
import CsSessionStorageUtils from "../../../utils/CsSessionStorageUtils";
import { useBiometric } from "../../../hooks/useBiometric";
import {
  E_ChannelOptions,
  T_BiometricCapture,
} from "../../../globalTypes/GlobalTypes";
import {
  DEVICE_TYPE,
  GTAScreenType,
  REGISTER_BIO_METRIC,
  SCREEN_TYPE,
} from "../../../utils/constants";
import { useLazyRegisterBiometricQuery } from "../../Feature_Login/Login_Api";
import {
  generateDeviceID,
  getMobileOperatingSystem,
  isBiometricSetUpCompleted,
} from "../../../utils/helper";
import {
  BIOMETRIC_DO_IT_LATER_STATUS,
  getCookie,
  setCookie,
} from "../../../utils/CSCookieHandler";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import TriggerGTAEvent from "../../../utils/GTA";

declare const window: any;

const CaptureBiometric: FC<{ onHide?: Function }> = ({ onHide = () => {} }) => {
  const appDispatch = useAppDispatch();
  const [doItLater, setDoItLater] = useState<boolean>(
    getCookie(BIOMETRIC_DO_IT_LATER_STATUS) === "true"
  );
  const [isBiometricCapture, setIsBiometricCapture] = useState<boolean>(
    CsSessionStorageUtils.get("BIOMETRIC_SETUP_STATUS")
  );
  const cmsData = useAppSelector((state) => state.CmsSlice.CmsPageVariableData);
  const cmsLogo =
    cmsData.find((i) => i.attributes.cmsType === "ABC Logo")?.attributes?.image
      ?.data?.attributes?.url ?? "";

  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);

  const generalAppSlice = useAppSelector(
    (state) => state.GeneralAppElementsSlice
  );

  const initiateBiometricScan = useBiometric("capture");

  const [registerBiometricAPI] = useLazyRegisterBiometricQuery();
  const [loading, setLoading] = useState<boolean>(false);

  const csAppSlice = useAppSelector((state) => state.CsAppSlice);

  useEffect(() => {
    appDispatch(updateLoadingState(false));
  }, []);

  const handleCleverTapCTAClick = (itemSelected: string) => {
    triggerCleverTapEvent("serv_login_securely_cta_click", {
      ScreenName: "Servicing Login Securely Option Selection Screen",
      ScreenType: SCREEN_TYPE.generalAppType,
      isPrevPageNameRequired: true,
      ctaText: itemSelected,
    });
  };

  const handleGTMClick = (itemSelected: string) => {
    TriggerGTAEvent("serv_login_securely_cta_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "servicing_login_securely_option_selection_screen",
      CTA_text: itemSelected,
    });
  };

  const setUpBiometricLater = () => {
    handleCleverTapCTAClick("Do it later");
    handleGTMClick("Do it later");
    CsSessionStorageUtils.set("BIOMETRIC_SETUP_STATUS", false);
    setCookie(BIOMETRIC_DO_IT_LATER_STATUS, "true", 30);
    setDoItLater(true);
    appDispatch({
      type: REGISTER_BIO_METRIC,
      payload: {},
    });
    if (window.ReactNativeWebView) {
      const message = {
        action: "BIO_INFO",
        payload: {}
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message)
      );
    }
    onHide();
  };

  const onBiometricSuccess = (result: T_BiometricCapture) => {
    let reqBodyforRegisterBiometric = {
      csUserId: userDetails?.CS_USER_ID,
      biometricToken: result?.biometricToken,
      mobileOs: getMobileOperatingSystem(),
      mobile: userDetails?.mobileNumber,
      deviceId: generateDeviceID(),
      appVersion:csAppSlice.NativeDeviceInfo?.appVersion
    };
    setLoading(true);
    registerBiometricAPI(reqBodyforRegisterBiometric)
      .then((res) => {
        if (!_.isEmpty(res.data?.payload)) {
          if (res.data?.code === 1) {
            console.log("Save Biometric Response", res.data?.payload);
            appDispatch({
              type: REGISTER_BIO_METRIC,
              payload: {
                biometricToken: result.biometricToken,
                mobile: reqBodyforRegisterBiometric.mobile,
                csUserId: reqBodyforRegisterBiometric.csUserId,
                deviceId: reqBodyforRegisterBiometric.deviceId,
              },
            });

            if (window.ReactNativeWebView) {
              const message = {
                action: "BIO_INFO",
                payload: {
                  biometricToken: result.biometricToken,
                  mobile: reqBodyforRegisterBiometric.mobile,
                  csUserId: reqBodyforRegisterBiometric.csUserId,
                  deviceId: reqBodyforRegisterBiometric.deviceId,
                },
              };
              window.ReactNativeWebView.postMessage(JSON.stringify(message));
              console.log(
                "Sending event to TWA React Native Android " + JSON.stringify(message)
              );
            }

            CsSessionStorageUtils.set("BIOMETRIC_SETUP_STATUS", true);
            setCookie(BIOMETRIC_DO_IT_LATER_STATUS, "false", 30);
            setIsBiometricCapture(true);
            setLoading(true);
            onHide();
          } else {
            setLoading(true);
            appDispatch(
              setError({
                error: res.data,
                message: res.data?.message,
              })
            );
            setUpBiometricLater();
          }
        } else {
          //console.log("Save Biometric API Error");
          appDispatch(
            setError({
              error: new Error("Error"),
              message: "Save Biometric API Error",
            })
          );
          setUpBiometricLater();
        }
      })
      .catch((err) => {
        // console.log("Save Biometric error", err);
        setError({
          error: err,
          message: err.message,
        });
        setUpBiometricLater();
      })
      .finally(() => {
        setLoading(true);
      });
  };

  const initiateBiometric = () => {
    handleCleverTapCTAClick("Enable device authentication");
    handleGTMClick("Enable device authentication");
    initiateBiometricScan("")
      ?.then((result) => {
        onBiometricSuccess(result as T_BiometricCapture);
      })
      .catch((err) => {
        setIsBiometricCapture(false);
      });
  };

  return !isBiometricCapture && !doItLater ? (
    <Backdrop
      open={true}
      style={{
        height: "100%",
        width: "100%",
        padding: "0rem",
        margin: "0rem",
        zIndex: "2999",
        backgroundColor: "white",
        display: "block",
      }}
    >
      <Box className="Biometricpage">
        <Box className="header-section">
          <CustomNetworkImage src={cmsLogo} alt="abc-logo-img" />
        </Box>
        <Box width="100%" marginTop={"2.2844rem"}>
          <Box display="flex" justifyContent="center">
            <img
              src={Image1}
              alt="Fingerprint"
              style={{ width: "6.8125rem", height: "6.8125rem" }}
            />
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Box sx={{ marginLeft: ".8438rem" }}>
              <img
                src={Image2}
                alt="Shield"
                style={{ width: "5.875rem", height: "5.875rem" }}
              />
            </Box>

            <Box sx={{ marginRight: ".8125rem" }}>
              <img
                src={Image4}
                alt="Password"
                style={{ width: "5.875rem", height: "5.878rem" }}
              />
            </Box>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="3"
            display="flex"
            justifyContent="center"
          >
            <img
              src={Image3}
              alt="Lock"
              style={{ width: "8.2069rem", height: "8.2069rem" }}
            />
          </Box>
        </Box>

        <Box className="background-image" sx={{ marginTop: "-5rem" }}>
          <Box sx={{ marginTop: "5rem" }}>
            <Typography
              fontWeight={600}
              fontSize={"1.5rem"}
              textAlign={"center"}
            >
              Securely login to your account
            </Typography>
            <Typography
              sx={{ textAlign: "center" }}
              fontWeight={400}
              fontSize={"1rem"}
              marginTop={".5rem"}
            >
              We ensure account safety through device
            </Typography>
            <Typography
              sx={{ textAlign: "center" }}
              fontWeight={400}
              fontSize={"1rem"}
            >
              authentication. You can also opt for an MPIN.
            </Typography>
          </Box>
          <Box
            mt={4}
            display="flex"
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
            marginTop={"3rem"}
          >
            {!loading && (
              <Button
                fullWidth
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#CA1F34",
                  width: "17.5rem",
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                  "&:active": {
                    backgroundColor: "#ffffff",
                  },
                  "&:focus": {
                    backgroundColor: "#ffffff",
                  },
                }}
                onClick={initiateBiometric}
              >
                Enable device authentication
              </Button>
            )}
            {loading ? (
              <CustomThreeDotsLoader />
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "600",
                  fontSize: ".875rem",
                  cursor: "pointer",
                  color: "#CA1F34",
                  marginTop: "1rem",
                }}
                onClick={setUpBiometricLater}
              >
                Do it later
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Backdrop>
  ) : (
    <></>
  );
};

export default CaptureBiometric;
